import { useEffect, useState } from 'react';
import { getMultimediaLevels } from '../../services/multimediaLevel/listMultimediaLevelService.js';

export const useMultimediaLevelsList = () => {
    const [multimediaLevels, setMultimediaLevels] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [error, setError] = useState('');
    // ordenamiento
    const [sortField, setSortField] = useState('');
    const [sortOrder, setSortOrder] = useState('asc');
    
    useEffect(() => {
        loadMultimediaLevels();
    }, []);

    const loadMultimediaLevels = async () => {
        const data = await getMultimediaLevels();
        data.sort((a, b) => a.name.localeCompare(b.name));
        setMultimediaLevels(data);
    };

    const handleSort = (field) => {
        const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';

        setSortField(field);
        setSortOrder(order);

        setMultimediaLevels(prev =>
            [...prev].sort((a, b) => {
                const aValue = field.split('.').reduce((o, i) => o?.[i], a);
                const bValue = field.split('.').reduce((o, i) => o?.[i], b);

                if (aValue < bValue) return order === 'asc' ? -1 : 1;
                if (aValue > bValue) return order === 'asc' ? 1 : -1;
                return 0;
            })
        );
    };

    return {
        multimediaLevels,
        searchTerm,
        setSearchTerm,
        currentPage,
        setCurrentPage,
        itemsPerPage,
        error,
        setError,
        sortField,
        sortOrder,
        setSortField,
        setSortOrder,
        handleSort
    };
}